import { createSlice, PayloadAction, createAsyncThunk, current } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { mdcApi } from "./mdcApi";
import { Series } from "../Common/Types/types";
import { flatten, isEqual } from "lodash";

const initialState: any = {
    mdcData: [],
    selectedSeries:[],
    loadingState: undefined,
    errorMessage: undefined,
  };

  export const updateMdcData = createAsyncThunk<any,any>(
    "mdc/updateMdcData",
    async (params:any) => {
      const response = await mdcApi.fetchData(params)
      return response;
    }
  );
  
  export const addToMdcData = createAsyncThunk<any,any>(
    "mdc/addToMdcData",
    async (params:any) => {
      const response:any = await mdcApi.fetchData(params)
      //console.log(response)
        if (response != null) {
            if (response.length === 0) {
                alert("no data found for: " + params.seriesObjects[0].seriesID)
                return null;
            }
            return response[0];
        }
    }
  );

  const mdcSlice = createSlice({
    name: "mdc",
    initialState,
    reducers: {
      removeSeries(state,action){
        state.mdcData = state.mdcData.filter((obj)=>!(obj.seriesID === action.payload))
        state.selectedSeries = state.selectedSeries.filter((obj)=>!(flatten(Object.values(obj)).includes(action.payload)))
      },
      updateSelectedSeries(state,action){
        state.selectedSeries = action.payload
      }
    },
    extraReducers: (builder) => {
      builder.addCase(updateMdcData.fulfilled, (state, action) => {
        return {
          ...state,
          loadingState: "fulfilled",
          errorMessage: undefined,
          mdcData: action.payload
        };
      });
      builder.addCase(updateMdcData.rejected, (state, action) => {
        return {
          ...state,
          loadingState: "rejected",
          errorMessage: "error",
        };
      });
      builder.addCase(updateMdcData.pending, (state, action) => {
        return {
          ...state,
          loadingState: "pending",
          errorMessage: undefined,
        };
      });
      /////
      builder.addCase(addToMdcData.fulfilled, (state, action) => {
        if(action.payload === null){
          return {
            ...state,
            loadingState: "fulfilled",
            errorMessage: undefined,
            mdcData: [...state.mdcData]
          }
        }
        return {
          ...state,
          loadingState: "fulfilled",
          errorMessage: undefined,
          mdcData: [...state.mdcData, action.payload],
        }
      });
      builder.addCase(addToMdcData.rejected, (state, action) => {
        return {
          ...state,
          loadingState: "rejected",
          errorMessage: "error",
        };
      });
      builder.addCase(addToMdcData.pending, (state, action) => {
        return {
          ...state,
          loadingState: "pending",
          errorMessage: undefined,
        };
      });
    },
  });

export const {removeSeries, updateSelectedSeries} = mdcSlice.actions;
export const getMdcDataSelector = (state: RootState) => state.mdc;
export const loadingMdcDataSelector = (state: RootState) => state.mdc.loadingState;
export default mdcSlice.reducer;
